export default function searchModal () {
  const $ = require('jquery')
  $('#searchModal').on('show.bs.modal', function () {
    $('body').addClass('search-modal')
  }).on('hidden.bs.modal', function () {
    $('body').removeClass('search-modal')
  })

  if ($('html.ie-11').length === 0) {
    $('#searchModal').on('shown.bs.modal', function () {
      $('#searchModal input[name="q"]').focus()
    })
  }
}
